module.exports = __webpack_public_path__ + "static/media/grand_mum_standing.8d405dff.svg";